// extracted by mini-css-extract-plugin
module.exports = {"widget":"e_mm","button":"e_nm","icon":"e_om","count":"e_pm"};